import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button } from '@knitknot/shared/components/ui/button';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(_error: Error, _info: ErrorInfo) {
    // Intentionally empty — no external logging wired up yet.
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex flex-1 flex-col items-center justify-center gap-3 p-8">
          <h2 className="text-lg font-semibold text-ink-strong">
            Something went wrong
          </h2>
          <p className="max-w-md text-center text-sm text-ink-supporting">
            {this.state.error.message}
          </p>
          <Button
            variant="outline"
            size="sm"
            onClick={() => window.location.reload()}
          >
            Reload page
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}
